const ID_TEMPLATE_KEY = "Template" as string;

/**
 * @description get templates form localStorage
 */
export const getTemplate = (): string | null => {
  return window.localStorage.getItem(ID_TEMPLATE_KEY);
};

/**
 * @description save token into localStorage
 * @param template: Array
 */
export const saveTemplate = (template): void => {
  window.localStorage.setItem(ID_TEMPLATE_KEY, template);
};

/**
 * @description remove template form localStorage
 */
export const destroyTemplate = (): void => {
  window.localStorage.removeItem(ID_TEMPLATE_KEY);
};

export const returnChekedTemplate = () => {
  const list = window.localStorage.getItem(ID_TEMPLATE_KEY);
  if (list === null || list === "[]") {
    return false;
  } else {
    const value = JSON.parse(list);
    const length = value.filter((item) => item.checked === true).length;
    if (length > 0) {
      return value.filter((item) => item.checked === true)[0].question;
    } else {
      return false;
    }
  }
};

export const isThereRecord = () => {
  const list = window.localStorage.getItem(ID_TEMPLATE_KEY);
  if (list === null || list === "[]") {
    return false;
  } else {
    return true;
  }
};

export default {
  getTemplate,
  saveTemplate,
  destroyTemplate,
  returnChekedTemplate,
  isThereRecord,
};
